import React from 'react';
import { FormattedMessage } from 'react-intl';
import {
    makeStyles,
    AppBar,
} from '@material-ui/core';
import useRouter from 'utils/useRouter';
import { StyledTabs, StyledTab } from 'components/CustomTab'
import PropTypes from 'prop-types';
import useStyles from '../styles';

const UsersTab = ({ value }) => {
    const classes = useStyles();
    const router = useRouter();
    const handleTabChange = (event, newValue) => {
        router.history.push("/internal/" + newValue);
    };
    return (
        <AppBar position="static" className={classes.appbar}>
            <StyledTabs value={value} onChange={handleTabChange} aria-label="services tabs" className={classes.tabsContainer}>
                <StyledTab value="users" className={classes.tabContainer} label={<FormattedMessage id="navbar.users" />} />
                <StyledTab value="teams" className={classes.tabContainer} label={<FormattedMessage id="navbar.users.internal.teams" />} />
                <StyledTab value="admins" className={classes.tabContainer} label={<FormattedMessage id="navbar.admins" />} />
            </StyledTabs >
        </AppBar>
    );
};
UsersTab.propTypes = {
    value: PropTypes.any
};
export default UsersTab;
